import { configApi } from '../http-client.js'

export const getServerTimezoneInfo = () => {
	return configApi.get('/api/ConfigData/ServerTimezone')
}
